<template>
	<!-- Custom form component with validation support-->
	<div class="ui-form">
		<form
			:style="{filter: isProcessing ? 'blur(2px)' : 'none'}"
			novalidate
			@submit.stop.prevent="submit"
		>
			<slot/>
		</form>
		<div v-if="isProcessing" class="ui-form__processing">
			<ui-progress
				:diameter="60"
				:stroke="2"
			/>
		</div>
	</div>
</template>

<script>
import UiProgress from "lib/components/ui/Progress";

export default {
	name: "Form",
	components: {
		UiProgress
	},
	props: {
		isProcessing: {
			type: Boolean,
			default: false,
			required: false
		},
		valid: {
			type: Boolean,
			default: true,
			required: false
		}
	},
	data() {
		return {
			inputs: {}
		};
	},
	watch: {
		inputs: {
			deep: true,
			handler() {
				this.$emit("update:valid", this.isValid());
			}
		}
	},
	methods: {
		isValid() {
			return Object.values(this.inputs).every((input) => input.valid);
		},
		submit(event) {
			if (!this.valid || this.isProcessing)
				return;

			this.$emit("submit", event);
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-form {
	position: relative;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	.ui-form__processing {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 11;
	}
}
</style>
